export enum WorkflowTemplateOption {
  Blank = "Blank",
  UseAnotherWorkflow = "UseAnotherWorkflow"
}
